import { render, staticRenderFns } from "./ModalJustifyOne.vue?vue&type=template&id=74a7dd55&scoped=true&"
import script from "./ModalJustifyOne.vue?vue&type=script&lang=js&"
export * from "./ModalJustifyOne.vue?vue&type=script&lang=js&"
import style0 from "./ModalJustifyOne.vue?vue&type=style&index=0&id=74a7dd55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7dd55",
  null
  
)

export default component.exports